import App from './App.vue'
import Domain from 'domain-service'
import Env from 'env-service'
import GuiBus from 'gui-bus-plugin'
import VueGtag from 'vue-gtag'
// use IIFE to allow async/await feature for the whole login process
;(async () => {
  function loadScript(scrpt) {
    return new Promise(resolve => {
      scrpt.addEventListener('load', resolve)
      document.head.appendChild(scrpt)
    })
  }

  let scriptPromises = []
  // Load externalized Vuetify JS files - make sure they load only once and leverage browser cache
  if (typeof window.Vuetify != 'function') {
    window.Vuetify = () => {}
    const scrpt = document.createElement('script')
    scrpt.setAttribute('src', '/assets/v1/vuetify.min.js') // This url must not contain version number, to allow for hot-swapping
    // ensure that Vuetify is loaded before going next step
    scriptPromises.push(loadScript(scrpt))
  }
  if (typeof VuetifyAdacadoTheme != 'object') {
    const scrpt = document.createElement('script')
    scrpt.setAttribute('src', '/assets/v1/vuetifyAdacadoTheme.js') // This url must not contain version number, to allow for hot-swapping
    // ensure that VuetifyAdacadoTheme is loaded before going next step
    scriptPromises.push(loadScript(scrpt))
  }
  await Promise.all(scriptPromises)

  const cssAssets = [
    '/assets/v1/materialdesignicons.min.css',
    '/assets/v1/roboto-fontface.css',
    '/assets/v1/vuetify.min.css',
    '/assets/v1/adacado.css',
  ]
  const stylesheets = Array.from(document.styleSheets)
  cssAssets
    .map(ca => {
      if (Env.IS_LOCAL_CONNECTION) {
        return `https://localhost:8080${ca}`
      } else {
        return Domain.decorateWithApplicationDomain`${ca}`
      }
    })
    .forEach(ca => {
      if (!stylesheets.find(s => s.href == ca)) {
        const newStyleTag = document.createElement('link')
        newStyleTag.rel = 'stylesheet'
        newStyleTag.href = ca
        document.head.appendChild(newStyleTag)
      }
    })

  // Use Adacado Pub/Sub for inter-FEMS communication
  Vue.use(GuiBus)

  Vue.config.productionTip = false

  Vue.use(Vuetify)

  Vue.use(VueGtag, {
    config: {
      id: 'G-TR916QP441',
      params: {
        send_page_view: true,
      },
    },
  })

  // Render login screen (redirect might happen after screen is rendered (too bad))
  // Attach render function to window
  window.adacado_render_functions = window.adacado_render_functions || {}
  let containerId = undefined
  // femsName and femsVersion are injected by webpack - see vue.config.js
  // eslint-disable-next-line
  window.adacado_render_functions[`${__femsName__}_${__femsVersion__}`] = c => {
    containerId = c
    init()
  }

  let isInitComplete = false
  function init() {
    // Proceed to instantiate application only if:
    // - FEMS application render function has fired
    if (containerId !== undefined && !isInitComplete) {
      isInitComplete = true
      // Data needed to initialize this FEMS should come from (in order of priority)
      // 1) Restful URL
      // 2) Parent DOM element data- attributes
      const parentContainer = document.getElementById(containerId)
      const vPreContainer =
        (parentContainer && parentContainer.querySelector('div')) || parentContainer
      const childContainer = parentContainer && parentContainer.querySelector('div')
      const d =
        (parentContainer &&
          parentContainer.dataset &&
          parentContainer.dataset.adacadoDataset &&
          JSON.parse(parentContainer.dataset.adacadoDataset)) ||
        {}
      const myInstanceId = d.instanceId
      const myInstanceHooks =
        (window.adacado.instanceHooks && window.adacado.instanceHooks[myInstanceId]) || {}
      const vmInstance = new Vue({
        vuetify: new Vuetify({
          theme: {
            themes: VuetifyAdacadoTheme,
          },
        }),
        el: childContainer || parentContainer,
        mounted() {
          if (Array.isArray(myInstanceHooks.mounted)) {
            myInstanceHooks.mounted.forEach(callback => callback())
          }
        },
        render(h) {
          return h(App, { props: { dataset: parentContainer.dataset } })
        },
      })
      // Finally, attach teardown function to window - using variables in scope
      window.adacado_teardown_functions = window.adacado_teardown_functions || {}
      // __femsName__ and __femsVersion__ are injected (variables made available) by webpack - see vue.config.js
      // eslint-disable-next-line
      window.adacado_teardown_functions[`${__femsName__}_${__femsVersion__}_${containerId||''}`] = () => {
        vmInstance.$destroy()
        const vm = vPreContainer.querySelector('div')
        if (vm) {
          vPreContainer.removeChild(vm)
        }
        isInitComplete = false
      }
    }
  }
  init()
})()
